import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';

const BASE_PATHNAME = 'documents';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const getByIds = ({ ids }) => Promise.all(ids.map((id) => getById({ id })));

  return {
    getList: getDefaultListHandler({ url: BASE_PATHNAME, dataSource }),

    getById,

    getByIds,

    getEmptyList: getDefaultEmptyList,
  };
};
